module.exports = __webpack_public_path__ + "static/media/sports_5.a1b5988a.jpg";